import React, { useState } from "react";
import SlideInOnScroll from "../assets/animations/SlideInScroll";

const FAQSection = () => {
  const [openAccordions, setOpenAccordions] = useState<number[]>([]);

  const toggleAccordion = (index: number) => {
    setOpenAccordions((prevOpenAccordions) => {
      if (prevOpenAccordions.includes(index)) {
        return prevOpenAccordions.filter((i) => i !== index);
      } else {
        return [...prevOpenAccordions, index];
      }
    });
  };

  const faqData = [
    {
      question: "What is Haircare AI?",
      answer: "An iOS and android app for personalized hair care.",
    },
    {
      question: "How does Haircare AI personalize recommendations?",
      answer:
        "Haircare AI analyzes your hair type, texture, specific needs, etc to offer tailored hair care advice and routines.",
    },
    {
      question: "Is Haircare AI suitable for all hair types?",
      answer:
        "Yes, Haircare AI is designed to cater to all hair types and textures, providing customized care for each user.",
    },
    {
      question: "Can I track my hair care progress with Haircare AI?",
      answer:
        "Yes, you can schedule routines, track your progress, and see how your hair improves over time.",
    },
    {
      question: "What is the social network feature?",
      answer:
        "The social network feature allows you to connect with others who share your hair type, follow their hair care journeys, and exchange tips and advice.",
    },
    {
      question: "When will the app be available?",
      answer:
        "Haircare AI will be available soon on various platforms. Join our waitlist to stay updated on the release date.",
    },
  ];

  return (
    <div className="flex flex-col justify-center items-center mt-[60px] w-full mb-[60px]">
      <div>
        <SlideInOnScroll id="101022" delay={100}>
          <div className="items-center flex justify-center bg-gray-900 w-[170px] py-4 rounded-full">
            <h1 className="text-white font-semibold text-[17px]">
              Haircare AI
            </h1>
          </div>
        </SlideInOnScroll>
      </div>
      <div>
        <SlideInOnScroll id="10102" delay={100}>
          <h1 className="text-gray-800 noto-sans-tc-h1 lg:text-[50px] text-[44px] pt-4 text-center font-semibold">
            Frequently asked questions
          </h1>
        </SlideInOnScroll>
      </div>

      <div className="w-full lg:mt-[70px] mt-[50px] lg:px-20">
        <SlideInOnScroll id="101023" delay={100}>
          <div className="flex flex-col">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className="border-b border-gray-300 last:border-none"
              >
                <div
                  className="py-6 cursor-pointer"
                  onClick={() => toggleAccordion(index)}
                >
                  <div className="flex flex-row items-center justify-between">
                    <div>
                      <h1 className="font-semibold text-[16px]">
                        {faq.question}
                      </h1>
                    </div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className={`size-6 transition-transform ${
                          openAccordions.includes(index) ? "rotate-45" : ""
                        }`}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 4.5v15m7.5-7.5h-15"
                        />
                      </svg>
                    </div>
                  </div>
                  {openAccordions.includes(index) && (
                    <div className="pt-4">
                      <p className="text-gray-500 text-[15px]">{faq.answer}</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </SlideInOnScroll>
      </div>
    </div>
  );
};

export default FAQSection;
